import type { FC } from "react";

import { ChangeValue } from "@similarweb/ui-components";

import BoxTitle from "pro-features/components/BoxTitle/src/BoxTitle";
import { NO_DATA_SIGN } from "app/filters/const";
import { translate } from "app/filters/i18nFilter";
import { percentageSignFilter } from "app/filters/ngFilters";
import { normalizeForMinValue } from "app/pages/website-analysis/traffic-sources/search/common/utils";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import {
    ChangeContainer,
    DataGrowthBasis,
    DataRowContainer,
    DataRowTitle,
    DataRowValue,
    DataTitle,
    DataValue,
} from "./styledComponents";

interface INumberWithChangeRow {
    field: string;
    displayName: string;
    tooltip?: string;
    displayNoData?: boolean;
    invertChangeColor?: boolean;
    filter?: (value: number) => string;
}

interface INumberWithChangeData {
    value: number;
    change: number;
}

interface INumberWithChangeCellTemplate {
    data: INumberWithChangeData;
    row: INumberWithChangeRow;
}

export const NumberWithChangeCellTemplate: FC<INumberWithChangeCellTemplate> = ({ data, row }) => {
    const { field, displayName, tooltip, filter, displayNoData, invertChangeColor = false } = row;
    const { value, change } = data[field];
    const isPositive = change > 0;
    let valueToDisplay: string | number;
    if (value) {
        valueToDisplay = filter(normalizeForMinValue(value));
    } else if (!value && displayNoData) {
        valueToDisplay = NO_DATA_SIGN;
    }

    return (
        <DataRowContainer>
            <BoxTitle
                Container={DataRowTitle}
                tooltip={tooltip}
            >
                <DataTitle>{displayName}</DataTitle>
            </BoxTitle>
            <FlexColumn
                justifyContent="center"
                alignItems="flex-end"
            >
                <DataRowValue>
                    <DataValue>{valueToDisplay}</DataValue>
                    {change ? (
                        <ChangeContainer>
                            <ChangeValue
                                value={percentageSignFilter()(Math.abs(change), 2)}
                                isDecrease={!isPositive}
                                className="data-row-change-value"
                                invertColors={invertChangeColor}
                            />
                            <DataGrowthBasis>
                                ({translate("keyword.analysis.overview.page.v2.data_row.growth_basis")})
                            </DataGrowthBasis>
                        </ChangeContainer>
                    ) : null}
                </DataRowValue>
            </FlexColumn>
        </DataRowContainer>
    );
};
